<template>
  <modal-wrapper :shown="updateExists && canceled === false">
    <div class="px-4">
      <div class="mt-2 text-lg font-medium text-center">
        There's an update available for Dobble!
      </div>
      <action-button class="mt-6" @click="refreshApp">
        Refresh app to install
      </action-button>
      <action-button class="mt-3" type="outline" @click="canceled = true">
        Cancel
      </action-button>
    </div>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from "@/components/ModalWrapper";
import ActionButton from "@/components/inputs/ActionButton";

export default {
  components: {
    ModalWrapper,
    ActionButton,
  },
  data() {
    return {
      canceled: false,
      registration: null,
      updateExists: false,
    };
  },
  created() {
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // We'll also need to add 'refreshing' to our data originally set to false.
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });
  },
  methods: {
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },
    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) return;
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
  },
};
</script>
